
import { computed, defineComponent } from "vue-demi";

export default defineComponent({
  name: "NotificationsTaskTemplate",

  components: {
    NotificationsTag: () => import("@/modules/Notifications/components/NotificationsTag.vue"),
    NotificationsDate: () => import("@/modules/Notifications/components/NotificationsDate.vue"),
  },

  props: {
    status: {
      type: String as () => "" | "overdue" | "due_soon",
      default: "default",
    },
    date: {
      type: String,
      default: "DD/MM/YYYY",
    },
    title: {
      type: String,
      default: "",
    },
    category: {
      type: String,
      default: "",
    },
  },

  emits: ["click"],

  setup(props, { emit }) {
    function onClick() {
      emit("click");
    }

    const isValidStatus = computed(() => ["overdue", "due_soon"].includes(props.status));

    return {
      onClick,
      isValidStatus,
    };
  },
});
